module.exports = __webpack_public_path__ + "static/media/job-post-promo-match-check.1760320a.svg";